<template>
  <el-tooltip
    :hide-after="hideTips"
    :disabled="disabled"
    effect="dark"
    :content="$t(content)"
    :placement="position"
    :open-delay="delay"
    @created="acreate"
  >
    <slot />
  </el-tooltip>
</template>
<script>
/*
 * @Author: lisiyi
 * @Date: 2019-12-25 16:16
 * @Last Modified by: lisiyi
 * @Last Modified time: 2019-12-25 16:16
 */
export default {
  props: {
    delay: { // tips出现延迟
      type: Number,
      default: 1000,
    },
    content: { // tips内容
      type: String,
      default: '',
    },
    position: { // tips位置
      type: String,
      default: 'top',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideTips: { // 点击tips消失默认 0：不消失1:消失
      type: Number,
      default: 1,
    },
  },
  methods: {
    /**
         * 创建tip后的回调
         */
    acreate(el) {
      this.$emit('AfterTipCreate', el)
    },
  },
}
</script>
